module.exports = __webpack_public_path__ + "img/howitworks_shareplan_phone3.9df3e07c.jpg";